import { render, staticRenderFns } from "./ExamPackagePractice.vue?vue&type=template&id=0c858be5&scoped=true&"
import script from "./ExamPackagePractice.vue?vue&type=script&lang=js&"
export * from "./ExamPackagePractice.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackagePractice.vue?vue&type=style&index=0&id=0c858be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c858be5",
  null
  
)

export default component.exports